import { useEffect } from "react";
import { useSiteSettings } from "@/hooks/useSiteSettings";

/**
 * Applies the favicon configured in the CMS (Site Settings) at runtime.
 * Falls back to the bundled favicon in index.html when none is set.
 */
export function SiteFavicon() {
  const { settings } = useSiteSettings();
  const faviconUrl = settings.faviconUrl;

  useEffect(() => {
    if (!faviconUrl) return;

    document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]').forEach((el) => el.remove());

    const link = document.createElement("link");
    link.rel = "icon";
    link.href = faviconUrl;
    document.head.appendChild(link);

    const apple = document.createElement("link");
    apple.rel = "apple-touch-icon";
    apple.href = faviconUrl;
    document.head.appendChild(apple);

    return () => {
      link.remove();
      apple.remove();
    };
  }, [faviconUrl]);

  return null;
}
